const hairType = [
  { label: "Straight", value: "Straight" },
  { label: "Wavy", value: "Wavy" },
  { label: "Curly", value: "Curly" },
  { label: "Bald on top", value: "Bald on top" },
  { label: "Other", value: "Other" },
];
export default hairType;
